import React from "react";

const Index = ({ title, subText, subTitle }) => {
  return (
    <>
      {subText ? <div className="subtext">{subText}</div> : null}
      {subTitle ? <div className="subTitle">{subTitle}</div> : null}
      {title ? <div className={`title ${subTitle? "": "title-pos"}`}>{title}</div> : null}
    </>
  );
};

export default Index;
